/** Extract enum from API value (string or { enum, label }). */
export function enumFrom(raw: unknown): string | undefined {
  if (raw == null) return undefined;
  if (typeof raw === "string") return raw;
  const o = raw as { enum?: string };
  return o?.enum;
}

export function labelFrom(raw: unknown): string | undefined {
  if (raw == null) return undefined;
  if (typeof raw === "string") return raw;
  const o = raw as { enum?: string; label?: string };
  return o?.label ?? o?.enum;
}
